import React from 'react';
import style from './ListYourProperty.module.css';
import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { getListPropertyData, sendPropertyRequest } from '../../Api/listProperty';
import { getPropertyTypes } from '../../Api/commonApis';
import { filterLanguage } from './../../utilities/filterFunction';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import i18n from 'i18next';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import Recaptcha from 'react-google-recaptcha';
import { recaptcha_key, recaptcha_secretKey } from './../../configiration/config';

function ListYourProperty() {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const [propertyData, setPropertyData] = useState({ name: '', email: '', phone: '', description: '', type: "", number_bedrooms: '' })
    const [errors, setErrors] = useState({ name: '', email: '', phone: '', description: '', type: "", number_bedrooms: '' })
    const [propertyDetails, setPropertyDetails] = useState({})
    const [types, setTypes] = useState([]);
    const [loading, setLoading] = useState(false);
    let phoneRef = useRef();
    let refRecaptcha=useRef();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    // get types
    useEffect(() => {
        getPropertyTypes().then((res) => {
            let type = { ...types }
            type = res.data.data
            setTypes(type);
        })
        // eslint-disable-next-line
    }, []);

    // get contact us
    useEffect(() => {
        getListPropertyData().then((res) => {
            let propertyDet = { ...propertyDetails }
            propertyDet = res.data.data.locales
            setPropertyDetails(filterLanguage(propertyDet));
        })
        // eslint-disable-next-line
    }, []);

    // inputs handler
    function inputsHandler(e) {
        let err = { ...errors }
        err[e.target.name] = '';
        setErrors(err);
        let property = { ...propertyData };
        property[e.target.name] = e.target.value;
        setPropertyData(property);
    }

    // on form submit handler
   async function submitpropertyHandler(e) {
        setLoading(true);
        e.preventDefault();
        let token= await refRecaptcha.current.executeAsync()
        let data= {...propertyData}
        data['g-recaptcha-response']=token;
        sendPropertyRequest(data).then(() => {
            Swal.fire({
                icon: 'success',
                text: "Property request sent successfully!"
            }).then(() => {
                document.getElementById('propertyForm').reset();
                for (const key in propertyData) {
                    propertyData[key] = '';
                }
                window.location.reload();
            }
            )
            setLoading(false);
        }).catch((error) => {
            refRecaptcha.current.reset();
            let err = { ...errors }
            for (const key in err) {
                if (error.response.data.data[key]) {
                    err = { ...err, [key]: error.response.data.data[key] };
                    setErrors(err);
                }
            }
            setLoading(false);
        })
    }

    function limitBedroomNums(e) {
        if (e.target.value > 10) {
            e.target.value = 10
        }
    }
    //set phone number
    function setPhoneNumber(e) {
        propertyData.phone = e
        let err = { ...errors }
        err.phone = '';
        setErrors(err);
    }

    return (
        <div>
            <div className={`${style.myCustomContainer} my-5`}>
                <div className={`${style.listProperty} py-4`}>
                    {propertyDetails && propertyDetails.length > 0 &&
                        <>
                            <h2 className={style.sectionTitle}>{propertyDetails[0].title !== null && propertyDetails[0].title}</h2>
                            <p> {propertyDetails[0].description !== null && propertyDetails[0].description}</p>
                        </>
                    }
                    <form onSubmit={submitpropertyHandler} id='propertyForm'>
                        <div className={`${style.formInputs}`}>
                            <div>
                                <div className="mb-3">
                                    <label htmlFor="name" className="form-label">{t('name')}</label>
                                    <input type="text" className="form-control" id="name" name='name' onChange={inputsHandler} required />
                                    <div className='text-danger'>{errors.name}</div>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="email" className="form-label">{t('email')}</label>
                                    <input type="email" className="form-control" id="email" name='email' onChange={inputsHandler} required />
                                    <div className='text-danger'>{errors.email}</div>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">{t('phone')}</label>
                                    <PhoneInput countryCodeEditable={false} country={'ae'} onlyCountries={['ae']} ref={phoneRef} id="phone" name='phone' onChange={(e) => { setPhoneNumber(e) }} required />
                                    <div className='text-danger'>{errors.phone}</div>
                                </div>
                                <div className={`${style.whatDiv}`}>
                                    <span>{t('what-do-you-have')}</span>
                                </div>
                                <div >
                                    <Swiper
                                        dir={i18n.language === 'en' ? 'ltr' : 'rtl'}
                                        spaceBetween={20}
                                        slidesPerView={2}
                                        autoplay={{
                                            delay: 3500,
                                            disableOnInteraction: true,
                                        }}
                                        breakpoints={{
                                            1050: {
                                                slidesPerView: 3
                                            },
                                            800: {
                                                slidesPerView: 3
                                            },
                                            700: {
                                                slidesPerView: 3
                                            },
                                            600: {
                                                slidesPerView: 3
                                            },
                                            500: {
                                                slidesPerView: 3
                                            },
                                            300: {
                                                slidesPerView: 3
                                            },
                                            200: {
                                                slidesPerView: 3
                                            }
                                        }}
                                    >

                                        {types && types.length > 0 && types.map((type) => {
                                            let selectedType = filterLanguage(type.locales)
                                            return (
                                                <SwiperSlide key={type.slug}>
                                                    <input type="radio" name='type' id={type.slug} value={type.id} onChange={inputsHandler} />
                                                    <label htmlFor={type.slug} className={`${style.propertyType} propertyTypes`}>
                                                        <span>{selectedType[0].name !== null && selectedType[0].name}</span>
                                                    </label>
                                                </SwiperSlide>
                                            )
                                        })}
                                    </Swiper>
                                </div>
                                <div className='text-danger'>{errors.type}</div>
                                <div className={`${style.searchElement} my-3`}>
                                    <label htmlFor="bedroom" className="form-label">{t('bedroom')}</label>
                                    <input type="number" name='number_bedrooms' placeholder={t('number-bedrooms')} id='bedroom' className="form-control" min='1' max='30' onInput={limitBedroomNums} onChange={inputsHandler} required />
                                    <div className='text-danger'>{errors.number_bedrooms}</div>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlTextarea1" className="form-label mb-1">{t('describe-property')}</label>
                                    <textarea className="form-control" name='description' id="exampleFormControlTextarea1" rows="3" onChange={inputsHandler} required></textarea>
                                    <div className='text-danger'>{errors.description}</div>
                                </div>
                                <Recaptcha
                                    ref={refRecaptcha}  
                                    sitekey={recaptcha_key} 
                                    secretkey={recaptcha_secretKey}
                                    size={'invisible'}
                                />
                                {loading ?
                                    <div className={`${style.requestBtn}`}>
                                        <button type='submit'><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            <span className='mx-2'>{t('sending')}...</span> </button>
                                    </div>
                                    :
                                    <div className={`${style.requestBtn}`}>
                                        <button type='submit'>{t('request-to-list')}</button>
                                    </div>
                                }
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default ListYourProperty